/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Action from './Action/index'
import LastSyncStatus from './LastSyncStatus/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content",
  closePopover
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Action
  viewPath={`${viewPath}/Action`}
 closePopover={closePopover}
/>
<LastSyncStatus
  viewPath={`${viewPath}/LastSyncStatus`}
 closePopover={closePopover}
/>
</div>
{children}
</React.Fragment>)
}